import { IMAGE_ALT } from '../../seo/imageAltText';
import PictureImage from '../../components/Common/PictureImage';
import React from 'react';
import { Link } from 'react-router-dom';
import './ShopifyIntegration.css';

const ShopifyIntegration: React.FC = () => {
  return (
    <section className="shopify-integration">
      <div className="shopify-integration-container">
        <div className="shopify-integration-section">
          <div className="shopify-integration-content">
            <div className="shopify-integration-text">
              <h2 className="shopify-integration-title">
                <span className="shopify-integration-highlight">Seamless Shopify Integration: </span>
                <span style={{ color: '#e07b20' }}>Zero Downtime, Real-Time Visibility</span>
              </h2>
              <p className="shopify-integration-description">
                Our Shopify fulfilment solution in the UK integrates seamlessly with your store, providing real-time
                visibility into orders, inventory, and fulfilment activity. Through our{' '}
                <Link to="/our-fulfilment-center" className="shopify-inline-link">
                  UK fulfilment centre
                </Link>
                , you can track stock levels, monitor order progress, and manage operations from a single platform via
                our{' '}
                <Link to="/wms-integrations" className="shopify-inline-link">
                  WMS integrations
                </Link>
                . This helps improve order processing, maintain inventory accuracy, and support scalable{' '}
                <Link to="/blog/ecommerce-fulfilment-guide-uk" className="shopify-inline-link">
                  ecommerce growth
                </Link>
                .
              </p>
            </div>

            <div className="shopify-integration-image-wrapper">
              <PictureImage
                width={800}
                height={800}
                src="/Images/ShopifyPage/9.webp"
                alt={IMAGE_ALT.shopifyIntegrationOrders}
                className="shopify-integration-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="shopify-integration-section shopify-integration-section-reverse">
          <div className="shopify-integration-content shopify-integration-content-reverse">
            <div className="shopify-integration-text">
              <h2 className="shopify-integration-title">
                <span className="shopify-integration-highlight">Storage solutions fit for your </span>
                <span style={{ color: '#e07b20' }}>Shopify Products</span>
              </h2>
              <p className="shopify-integration-description">
                Secure warehouse storage solutions designed for growing ecommerce brands. Our fulfilment centre in the UK
                provides flexible storage capacity,{' '}
                <Link to="/multi-channel-fulfillment-services" className="shopify-inline-link">
                  inventory management
                </Link>
                , and organised stock control for businesses across FMCG, sports nutrition,{' '}
                <Link to="/fashion-apparel-fulfilment-uk" className="shopify-inline-link">
                  fashion
                </Link>
                ,{' '}
                <Link to="/beauty-cosmetics-fulfilment-uk" className="shopify-inline-link">
                  beauty
                </Link>
                , and other sectors. Combined with our Shopify fulfilment services in the UK, we help brands store
                inventory efficiently while maintaining accurate stock visibility and supporting long-term growth.
              </p>
            </div>

            <div className="shopify-integration-image-wrapper">
              <PictureImage
                width={800}
                height={800}
                src="/Images/ShopifyPage/6.webp"
                alt={IMAGE_ALT.shopifyIntegrationStorage}
                className="shopify-integration-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopifyIntegration;
